module.exports = __webpack_public_path__ + "static/img/B36.c1c828e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/B36.png
// module id = 68
// module chunks = 1